import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Sentry } from './sentry';

import AppRouter from '@router/AppRouter';
import { GlobalSnackbar, Loader, PageWrapper } from '@components';
import {
  useAxiosConfig,
  useFetchProfile,
  useAppIsLoading,
  useObserveTitle,
  useAnalytics,
} from '@hooks';

const App: React.FC = () => {
  const { isAuthInitialized } = useAxiosConfig();
  useFetchProfile({ isAuthInitialized });
  useObserveTitle();
  useAnalytics();
  const isAppLoading = useAppIsLoading();

  if (isAppLoading) {
    return (
      <PageWrapper>
        <Loader showBrandLogo />
      </PageWrapper>
    );
  }

  return (
    <Sentry.ErrorBoundary
      fallback={
        <PageWrapper>
          <Loader showBrandLogo />
        </PageWrapper>
      }
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AppRouter />
        <GlobalSnackbar />
      </LocalizationProvider>
    </Sentry.ErrorBoundary>
  );
};

export default Sentry.withProfiler(App);
